// Page « Formulaire de réponse mariage » (référencement). En français : elle vise
// « formulaire réponse mariage », « formulaire mariage en ligne », « carton réponse
// mariage (texte, exemple) ». Les questions citées existent dans le RSVP de l'app.

import { Template } from '../common/TemplateCard';
import { FaqItem } from '../common/GuideLayout';

export const UPDATED = '2026-10-15';
export const READING_MINUTES = 7;

export const TOC = [
  { id: 'indispensables', label: 'Les questions indispensables' },
  { id: 'utiles', label: 'Les questions utiles' },
  { id: 'eviter', label: 'Ce qu’il vaut mieux éviter' },
  { id: 'exemple', label: 'Exemple de formulaire de réponse' },
  { id: 'carton', label: 'La version papier : le carton réponse' },
  { id: 'faq', label: 'Questions fréquentes' },
];

export const MUST = [
  {
    title: 'Le nom',
    text: 'Qui répond. Idéalement choisi dans votre liste d’invités plutôt que tapé à la main : pas de doublon, pas de faute.',
  },
  {
    title: 'La présence, événement par événement',
    text: 'Mairie, vin d’honneur, dîner, brunch : une réponse pour chaque moment où l’invité est convié.',
  },
  {
    title: 'Les personnes qui l’accompagnent',
    text: 'Conjoint, enfants : qui vient vraiment, nom par nom, pour le plan de table.',
  },
];

export const USEFUL = [
  {
    title: 'Le menu',
    text: 'Si vous proposez plusieurs plats : viande, poisson, végétarien. Le traiteur a ses chiffres.',
  },
  {
    title: 'Allergies et régimes',
    text: 'Sans gluten, fruits à coque, végétarien… En question facultative, à transmettre au traiteur.',
  },
  { title: 'La logistique', text: 'Navette, hébergement, heure d’arrivée : seulement si vous l’organisez.' },
  { title: 'Une chanson', text: 'Celle qui les fera danser : votre DJ a sa playlist toute prête.' },
  { title: 'Un mot pour les mariés', text: 'Facultatif, et souvent le plus beau souvenir du formulaire.' },
  {
    title: 'Téléphone ou email',
    text: 'Si vous n’avez pas encore leurs coordonnées, pour les dernières informations.',
  },
];

export const AVOID = [
  'Trop de questions : au-delà de 6 ou 7, les réponses traînent. Gardez l’essentiel.',
  'Demander le menu des enfants comme celui des adultes : prévoyez plutôt un menu enfant, compté à part.',
  'Des questions ouvertes partout : préférez des choix (oui / non, liste de menus), plus rapides à remplir et à compter.',
  'Parler du cadeau dans le formulaire : la liste de mariage a sa place sur votre page, pas dans les questions.',
];

// Exemple de formulaire tel que vos invités le voient
export const EXAMPLE = [
  { q: 'Votre nom', a: 'Choisi dans la liste des invités' },
  { q: 'Répondre aussi pour…', a: 'Les personnes de son entourage invitées' },
  { q: 'Serez-vous présent·e au vin d’honneur ?', a: 'Oui · Non' },
  { q: 'Serez-vous présent·e au dîner ?', a: 'Oui · Non' },
  { q: 'Votre menu', a: 'Viande · Poisson · Végétarien' },
  { q: 'Allergies ou régime alimentaire', a: 'Facultatif, réponse libre' },
  { q: 'La chanson qui vous fera danser', a: 'Facultatif' },
  { q: 'Un mot pour les mariés', a: 'Facultatif' },
];

export const CARDS: Template[] = [
  {
    title: 'Carton réponse classique',
    text: 'Mme, M. ………… assistera ☐ n’assistera pas ☐ au mariage de [vos prénoms] le [date du mariage]. Nombre de personnes : …… Menu : viande ☐ poisson ☐ végétarien ☐. Merci de répondre avant le [date].',
  },
  {
    title: 'Carton réponse par événement',
    text: '………… sera présent·e : à la cérémonie ☐ au vin d’honneur ☐ au dîner ☐ au brunch ☐. Nombre de personnes : …… Allergies : ……………… Réponse souhaitée avant le [date].',
  },
  {
    title: 'Carton avec QR code',
    text: 'Pour nous répondre, scannez ce QR code ou rendez-vous sur [adresse du site] avant le [date]. Merci !',
  },
];

export const FAQ: FaqItem[] = [
  {
    q: 'Quelles questions mettre dans un formulaire de réponse de mariage ?',
    a: 'L’essentiel : le nom, la présence à chaque événement et les personnes qui accompagnent. Puis, selon votre mariage : le menu, les allergies, la navette ou l’hébergement, et un mot pour les mariés.',
  },
  {
    q: 'Faut-il demander les allergies ?',
    a: 'Oui, en question facultative. Votre traiteur a besoin de les connaître à l’avance, et vos invités apprécient qu’on y pense.',
  },
  {
    q: 'Comment gérer les enfants dans le formulaire ?',
    a: 'Demandez leur présence comme pour les adultes, mais pas de choix de menu : prévoyez un menu enfant, compté à part pour le traiteur.',
  },
  {
    q: 'Formulaire en ligne ou carton réponse papier ?',
    a: 'En ligne, les réponses arrivent directement dans votre liste, sans timbre ni recopie. Le papier garde son charme : un QR code imprimé sur un petit carton concilie les deux.',
  },
  {
    q: 'Que mettre sur un carton réponse de mariage ?',
    a: 'Le nom, la présence (oui ou non) pour chaque moment, le nombre de personnes, le menu si vous en proposez, et la date limite de réponse.',
  },
  {
    q: 'Vos invités peuvent-ils modifier leur réponse ?',
    a: 'Avec un formulaire RSVP Please, oui : ils retrouvent leur réponse et la corrigent eux-mêmes. Avec un carton papier, il leur faudra vous prévenir.',
  },
];
